export const GENERAL = "general";
export const DOCUMENTS = "documents";
export const APPOINTMENTS = "appointments"
export const NOTES = "notes"